import { parseRawSetting } from '../helpers/parseRawSetting'
import { IMapping } from '../models/parsedMappings'

export const mapMappings = (rawMapping: string): IMapping[] => {
  return parseRawSetting<IMapping[]>({ setting: rawMapping, defaultValue: [] })
}
